import type * as definitions from "~/definitions";
import type { Meal } from "~/models";
import { deserialize } from "desero";
import { HttpRequest, send } from "schwi";
import { BASE_URL } from "~/core/constants";
import { Menu } from "~/models";

/**
 * Get all {@link Menu|menus} for a given identifier and restaurant.
 *
 * @param identifier - Where we should look for restaurants.
 * @param restaurant - Where we should look for menus.
 * @returns A list of all {@link Menu|menu} for the given restaurant.
 *
 * @example
 * const menus = await getMenusFrom("limoges", "r211");
 */
export async function getMenusFrom(identifier: string, restaurant: string): Promise<Array<Menu>> {
  const request = new HttpRequest.Builder(BASE_URL + `${identifier}/externe/menu2014.xml`).build();
  const response = await send(request);

  const xml = await response.toXML<{
    listemenus: {
      menu: Array<definitions.menu>;
    };
  }>();

  return xml.listemenus.menu.filter(
    (menu) => menu.restaurant === restaurant
  ).map((menu) => deserialize(Menu, menu));
};

export async function getMealsFromForDate(identifier: string, restaurant: string, date = new Date()): Promise<Array<Meal> | null> {
  const menus = await getMenusFrom(identifier, restaurant);

  return menus.find((menu) =>
    menu.date.getDate() === date.getDate()
    && menu.date.getMonth() === date.getMonth()
  )?.meals ?? null;
}
